import classnames from 'classnames';

import { CancelConfirmButtonsProps, CancelConfirmButtons } from '@components/ActionButtons/CancelConfirmButtons';

import { Popup, PopupModifiers } from '../Popup';

import style from './ConfirmPopup.module.scss';
import '@components/mixins/commonStyles.scss';

export interface PopupProps extends CancelConfirmButtonsProps {
    title?: string;
    description?: (() => React.ReactNode) | string;
    customWidth?: boolean;
    modifiers?: PopupModifiers[];
    stopPointerPropagation?: boolean;
    onOutOfContentClick?(): void;
    onCrossIconClick?(): void;
}

export const ConfirmPopup = ({
    title,
    description,
    customWidth,
    modifiers = [],
    stopPointerPropagation,
    onOutOfContentClick,
    onCrossIconClick,
    ...buttonsProps
}: PopupProps) => {
    return (
        <Popup
            modifiers={modifiers}
            stopPointerPropagation={stopPointerPropagation}
            onOutOfContentClick={onOutOfContentClick || buttonsProps.onCancel}
            onCrossIconClick={onCrossIconClick}
        >
            <div className={classnames([style.root, style.root_redesign, customWidth && style.root_customWidth])}>
                {title && <div className={classnames([style.title, 'font_h1'])}>{title}</div>}
                {description && (
                    <div className={classnames([style.description, 'font_h2'])}>
                        {typeof description === 'string' ? description : description()}
                    </div>
                )}
                <CancelConfirmButtons {...buttonsProps} />
            </div>
        </Popup>
    );
};
